module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"import-csv-error-title":"Wasn\u0027t possible to upload","import-csv-error-description":"Looks like the file isn\u0027t on CSV format."},"pt-BR":{"import-csv-error-title":"Não foi possível carregar o arquivo","import-csv-error-description":"Parece que o arquivo não está no formato CSV."}}')
  delete Component.options._Ctor
}
